module.exports = __webpack_public_path__ + "static/media/procedureEng.deb39d45.png";